import { getFaqs } from "../../services/faqs";

const state = {
  list: null
};

const getters = {};

const actions = {
  async getList({ commit, state }) {
    if (state.list) {
      return state.list;
    } else {
      const { data } = await getFaqs();

      commit("setList", data);
      return data;
    }
  }
};

const mutations = {
  setList(state, list) {
    state.list = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
